import { FC, useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Card, CardContent, CardHeader, Grid, IconButton, Link, Typography } from '@material-ui/core';
import { Link as RouterLink } from 'react-router-dom';
import EditIcon from '@material-ui/icons/Edit';
import { BankDetails, FileModel } from 'src/interfaces/new-channel-partner/channelPartner';
import { ImageDialogBox } from 'src/components/common/image-dialog';
import { ChevronDown as ChevronDownIcon } from '../../../icons/chevron-down';
import { ChevronLeft as ChevronLeftIcon } from '../../../icons/chevron-left';
import { EditBankInfo } from './editBankInfo';

interface BankInfoProps {
  bankDetails: BankDetails;
  updateBankDetails: (data: BankDetails) => Promise<boolean>;
}

export const BankInfoCard: FC<BankInfoProps> = (props) => {
  const { bankDetails, updateBankDetails } = props;
  const [displayBankInfo, setDisplayBankInfo] = useState<boolean>(true);
  const [openEditBasicInfo, setOpenEditBasicInfo] = useState<boolean>(false);
  const [openDocumentImageDialog, setOpenDocumentImageDialog] = useState<boolean>(false);
  const [documentImagePath, setDocumentImagePath] = useState('');

  const previewDocument = async (document) => {
    setOpenDocumentImageDialog(true);
    setDocumentImagePath(document.key);
  };

  const getGridItem = (label: string, value: string | FileModel) => (
    <Grid
      container
      direction="row"
    >
      <Grid
        item
        md={5}
        xs={8}
        sm={4}
      >
        <Typography
          variant="button"
        >
          {label}
        </Typography>
      </Grid>
      <Grid
        item
        md={7}
        xs={8}
        sm={4}
      >
        { typeof value !== 'string' ? (
          <Link
            title="Preview Document"
            color="primary"
            component={RouterLink}
            to=""
            sx={{ mt: 2, mr: 3 }}
            underline="none"
            variant="subtitle2"
            onClick={() => {
              previewDocument(value);
            }}
          >
            {value.name}
          </Link>
        ) : (
          <Typography
            noWrap
            color="#506176"
            variant="body2"
          >
            {value}
          </Typography>
        )}
      </Grid>

    </Grid>
  );

  return (
    <>
      <Card
        variant="outlined"
        sx={{ mt: 1 }}
      >
        <CardHeader
          titleTypographyProps={{ variant: 'h2' }}
          title="Bank Details"
          action={(
            <>
              {bankDetails?.ifscCode ? (
                <IconButton
                  sx={{ p: 0 }}
                  aria-label="edit"
                  onClick={() => setOpenEditBasicInfo(true)}
                >
                  <EditIcon />
                </IconButton>
              ) : (
                <Button
                  size="small"
                  color="primary"
                  onClick={() => setOpenEditBasicInfo(true)}
                  variant="contained"
                >
                  Add
                </Button>
              )}
              { bankDetails?.ifscCode && (
              <>
                { displayBankInfo && (
                <IconButton
                  sx={{ p: 0 }}
                  aria-label="view"
                  onClick={() => {
                    setDisplayBankInfo(false);
                  }}
                >
                  <ChevronDownIcon />
                </IconButton>
                )}
                { !displayBankInfo && (
                <IconButton
                  sx={{ p: 0 }}
                  aria-label="view"
                  onClick={() => {
                    setDisplayBankInfo(true);
                  }}
                >
                  <ChevronLeftIcon />
                </IconButton>
                )}
              </ >
              )}
            </>
          )}
        />
        {(bankDetails?.ifscCode) && (
          <>
            {displayBankInfo && (
            <CardContent>
              <Grid
                container
              >
                <Grid
                  item
                  md={6}
                  xs={12}
                  xl={4}
                >
                  {getGridItem('IFSC Code', bankDetails?.ifscCode)}
                  {getGridItem('Account Holder Name', bankDetails?.accountHolderName)}
                  {getGridItem('Account Number', bankDetails?.accountNumber?.toString())}
                  {getGridItem('Account Type', bankDetails?.accountType)}
                </Grid>
                <Grid
                  item
                  md={6}
                  xs={12}
                  xl={5}
                >
                  {getGridItem('Bank Name', bankDetails?.name)}
                  {getGridItem('Branch Name', bankDetails?.branch)}
                  {getGridItem('City', bankDetails?.city)}
                  {getGridItem('Cheque', bankDetails?.cheque)}
                </Grid>
              </Grid>
            </CardContent>
            )}
          </>
        )}
      </Card>
      {openDocumentImageDialog && (
      <ImageDialogBox
        onClose={() => setOpenDocumentImageDialog(false)}
        open={openDocumentImageDialog}
        imagePath={documentImagePath}
        docName="Bank Cheque"
        docNumber=""
        file={bankDetails?.cheque}
      />
      )}
      {openEditBasicInfo && (
      <EditBankInfo
        open={openEditBasicInfo}
        onClose={() => setOpenEditBasicInfo(false)}
        bankDetails={bankDetails}
        updateBankDetails={updateBankDetails}
      />
      )}
    </>
  );
};

BankInfoCard.propTypes = {
  // @ts-ignore
  bankDetails: PropTypes.object,
  updateBankDetails: PropTypes.func
};
